module.exports = __webpack_public_path__ + "img/__footer logo gps chile.47152a0c.png";